import React from 'react';

const SalesFilters = ({
    searchTerm,
    setSearchTerm,
    selectedConfig,
    setSelectedConfig,
    selectedBuilding,
    setSelectedBuilding,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    timePeriod,
    setTimePeriod,
    uniqueConfigs,
    uniqueBuildings,
    showSearchTerm,
    showConfigFilter,
    showBuildingFilter,
    showDateRange,
    showTimePeriodFilter,
    timePeriodOptions,
    handleTimePeriodChange,
    projectFilter, // Add project filter
    setProjectFilter, // Add setProjectFilter
    uniqueProjects //Add uniqueProjects
}) => {
    return (
        <div className="flex flex-wrap items-center gap-2">
            {showSearchTerm && (
                <input
                    type="text"
                    placeholder="Search Project..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="p-2 border rounded font-normal text-sm"
                />
            )}

            {/* Project Filter */}
            {uniqueProjects && (
                <select
                    value={projectFilter}
                    onChange={(e) => setProjectFilter(e.target.value)}
                    className="p-2 border rounded font-normal text-sm"
                >
                    <option value="">All Projects</option> {/* Default option */}
                    {uniqueProjects.map((project) => (
                        <option key={project} value={project}>
                            {project}
                        </option>
                    ))}
                </select>
            )}

            {showConfigFilter && uniqueConfigs && (
                <select
                    value={selectedConfig}
                    onChange={(e) => setSelectedConfig(e.target.value)}
                    className="p-2 border rounded font-normal text-sm"
                >
                    {uniqueConfigs.map((config) => (
                        <option key={config} value={config}>
                            {config === 'all' ? 'All Configs' : config}
                        </option>
                    ))}
                </select>
            )}

            {showBuildingFilter && uniqueBuildings && (
                <select
                    value={selectedBuilding}
                    onChange={(e) => setSelectedBuilding(e.target.value)}
                    className="p-2 border rounded font-normal text-sm"
                >
                    {uniqueBuildings.map((building) => (
                        <option key={building} value={building}>
                            {building === 'all' ? 'All Buildings' : building}
                        </option>
                    ))}
                </select>
            )}

            {showTimePeriodFilter && timePeriodOptions && (
                <select
                    value={timePeriod}
                    onChange={handleTimePeriodChange}
                    className="p-2 border rounded font-normal text-sm"
                >
                    {timePeriodOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            )}

            {showDateRange && (
                <>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="p-2 border rounded font-normal text-sm"
                    />
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="p-2 border rounded font-normal text-sm"
                    />
                </>
            )}
        </div>
    );
};

export default SalesFilters;